// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__6UvD5","card":"index_card__1Vz9t","logo":"index_logo__2R8AV"};